import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabels, heroImage, trackCheckout } from '../data/offer';
const highlights = ['Professional Coaching System', '5 Bonus Guides Included', 'Instant Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-14 px-4 overflow-hidden bg-canvas" data-id="element-140" data-mp="4n9ymkjy9k48">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-141" data-mp="1285ztvqq06q0">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-142" data-mp="xa4gd9pdu5e0">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/60 bg-gold/10 text-gold font-semibold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-143" data-mp="nb6llp1d5fmk">
            6-IN-1 COMPLETE BOXING COACHING SYSTEM
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold leading-tight mb-4 sm:mb-6 text-white" data-id="element-144" data-mp="3j8iyr3vxcowt">
            Solve an Entire Year of Boxing Sessions in Just{' '}
            <span className="text-gold" data-id="element-145" data-mp="39acy0plutotj">5 Minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-md md:max-w-xl my-2 sm:my-4 mb-6 sm:mb-8" data-id="element-146" data-mp="39cpbapgo3b09">
          <img src={heroImage} alt="Boxing Coach Ready — 6-in-1 complete coaching system box set with 6 volumes" className="relative z-10 w-full h-auto object-contain drop-shadow-[0_30px_50px_rgba(0,0,0,0.6)]" data-id="element-147" data-mp="2qjv7mrohv5bc" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-148" data-mp="2hl9sz7m58afu">
          <p className="text-sm sm:text-lg md:text-xl font-semibold text-white leading-snug max-w-2xl mx-auto mb-3" data-id="element-149" data-mp="nbbcixheu94r">
            6 Complete Volumes · 150 Ready-to-Coach Sessions · Session Finder · 5 Bonus Guides
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-mist leading-snug max-w-2xl mx-auto mb-6 sm:mb-8" data-id="element-150" data-mp="ddwwgyzefmcz">
            The complete professional coaching system for boxing coaches who want to spend less time
            planning and walk into every session knowing exactly what to teach, how to coach it, how
            to correct it, and what should come next.
          </p>
          <p className="font-display text-gold tracking-[0.2em] text-sm sm:text-base mb-3" data-id="element-151" data-mp="x1ef9pec31ga">
            Plan less. Coach more.
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-152" data-mp="3ltqeji9dp5w5">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-153" data-mp="3hrllakmueba1">
              {ctaLabels.hero}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-steel" data-id="element-154" data-mp="269hbq2txd128">
            {highlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-155" data-mp="2b20rn6g348a7">
                <CheckCircle size={14} className="text-gold" aria-hidden="true" data-id="element-156" data-mp="2fz0vrbtdj0yo" />
                <span data-id="element-157" data-mp="2ky42r1swzh9a">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}